import type { FunctionComponent } from 'react';
import Container from 'react-bootstrap/Container';

import './styles/styles.css';
import Header from '../../Header';
import { ReservationsTable } from '../../Tables/Reservations';

interface ReservationTableProps {
  fromGrouping?: boolean;
}

export const ReservationsDashboard: FunctionComponent<ReservationTableProps> = ({
  fromGrouping = false,
}: ReservationTableProps) => {
  return (
    <Container fluid className="reservation-list-container">
      <Header title="Reservations" />
      <ReservationsTable fromGrouping={fromGrouping} />
    </Container>
  );
};
